import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNotification } from 'hook/useNotification';
import { fErrors } from 'utils/formatError';

/**
 * Hook used to retrieve query data.
 * @param queryCall the RTK Query method
 * @param queryArgs the RTK Query arguments
 * @param queryOptions the RTK Query options
 * @param defaultValue the default value
 * @returns {{data: *[]}}
 */
export const useQueryData = (
  queryCall,
  queryArgs = undefined,
  queryOptions = undefined,
  defaultValue = []
) => {
  const { formatMessage: msg } = useIntl();
  const { addNotification } = useNotification();

  const { data, isLoading, isFetching, error, refetch } = queryCall(queryArgs, queryOptions);

  useEffect(() => {
    if (error) {
      try {
        addNotification({
          type: 'error',
          title: msg({ id: 'notification.error.title' }),
          message: fErrors(msg, error)
        });
      } catch (e) {
        // ignore
      }
    }
  }, [addNotification, data, error, isFetching, isLoading, msg]);

  return { loading: isLoading || isFetching, data: data || defaultValue, error, refetch };
};
